import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "discourse/select-kit/components/select-kit/select-kit-row";

@classNames("font-selector-row")
export default class FontSelectorRow extends SelectKitRowComponent {}
